import { CampaignLeadLists_campaign_leadLists } from 'types/apollo/CampaignLeadLists';

export const applyFilter = (list: CampaignLeadLists_campaign_leadLists[], { status, search }) => {
  let newList = list;
  if (search.length) {
    newList = newList.reduce((acc, cur) => {
      if (cur.originalFilename.includes(search)) {
        acc.push(cur);
      }
      return acc;
    }, [] as CampaignLeadLists_campaign_leadLists[]);
  }

  if (status.length > 0 && status.length < 5) {
    const hasSent = status.includes('SENT');
    newList = newList.reduce((acc, cur) => {
      if (hasSent && cur.sentToCampaignTimestamp) {
        acc.push(cur);
        return acc;
      }
      if (status.includes(cur.status)) {
        // Remove processed if its been sent to campaign
        if (cur.status === 'PROCESSED' && cur.sentToCampaignTimestamp) {
          return acc;
        }
        acc.push(cur);
      }
      return acc;
    }, [] as CampaignLeadLists_campaign_leadLists[]);
  }

  return newList;
};
